import { action, makeObservable } from 'mobx';

import { apiUrls } from 'shared/entities/domain';
import { IRootStore } from 'shared/entities/store/rootStore';
import {
  IOauthInfo,
  normalizeOauthInfo,
  OauthInfoServer
} from 'shared/entities/user';
import { FieldModel } from 'shared/models/form';
import { LoadingStageModel } from 'shared/models/loadingStage';

type AuthOauthStoreParams = {
  rootStore: IRootStore;
  accessRecoveryToken?: string;
};

export default class AuthOauthStore {
  rootStore: IRootStore;
  private readonly accessRecoveryToken?: string;

  readonly requestOauthLinksStage: LoadingStageModel = new LoadingStageModel();
  readonly oauthInfo: FieldModel<IOauthInfo | null> =
    new FieldModel<IOauthInfo | null>(null);

  private oauthLinksRequestKey: string | null = null;

  constructor({ rootStore, accessRecoveryToken }: AuthOauthStoreParams) {
    this.rootStore = rootStore;
    this.accessRecoveryToken = accessRecoveryToken;

    makeObservable(this, {
      requestOauthLinks: action
    });
  }

  requestOauthLinks = async (): Promise<BaseResponse> => {
    const requestKey = this.accessRecoveryToken ?? '';

    if (this.requestOauthLinksStage.isLoading) {
      return {
        isError: true
      };
    }

    if (
      this.requestOauthLinksStage.successfullyLoaded &&
      this.oauthLinksRequestKey === requestKey
    ) {
      return {
        isError: false
      };
    }

    this.requestOauthLinksStage.loading();

    const response = await this.rootStore.networkStore.api<OauthInfoServer>(
      apiUrls.OAUTH_LIST_LOGIN_URLS,
      {
        method: 'GET',
        data: {
          access_recovery_token: this.accessRecoveryToken
        }
      }
    );

    if (response.isError) {
      this.requestOauthLinksStage.error();
    } else {
      this.oauthInfo.changeValue(normalizeOauthInfo(response.data));
      this.oauthLinksRequestKey = requestKey;
      this.requestOauthLinksStage.success();
    }

    return response;
  };
}
